<template>
  <div class="contract-hotel-index-container">
    <div class="contract-hotel-brand-title">
      <h3>{{ brandName }} {{ $t('h4h.exclusiveHotel') }}</h3>
      <span class="contract-hotel-disclaimer">
        {{ $t('h4h.exclusiveHotelFinePrint', { quantity: 3}) }}
      </span>
    </div>
    <div class="contract-hotel-index">
      <div class="contract-hotel-filter">
        <RoomQty
          :contracted="true"
        />
        <IndexView
          class="contracted-index-view"
          :contracted="true"
        />
      </div>
      <div class="contract-hotel-list">
        <ContractHotelCard
          v-for="hotel in getContractedHotels"
          :key="hotel.index"
          :hotel="hotel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ContractHotelCard from './contract_hotel_card'
import RoomQty from '../h4h_search_form/room_quantity'
import IndexView from './index_view'
import { mapGetters } from 'vuex'

export default {
  components: {
    ContractHotelCard,
    RoomQty,
    IndexView
  },

  data() {
    return {
      brandName: window.brand_name,
    }
  },

  computed: {
    ...mapGetters('hotel', [
      'getContractedHotels'
    ])
  }
}
</script>
